import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';
import createIconBuilderFromCondUiKit from './condUiKitAdapter';

// cond-ui-kit icon data (from @conductor/cond-ui-kit/lib/components/icons/ProductIcon/IcoMoonData/user-circle-o-2.json)
// Used for NEW navigation
const userCircleO2IconData = {
	icon: {
		attrs: [{}, {}],
		grid: 0,
		isMulticolor: false,
		isMulticolor2: false,
		paths: [
			'M512.008 187.253c101.802 0 184.322 82.523 184.322 184.32 0 101.8-82.522 184.322-184.322 184.322s-184.32-82.522-184.32-184.322c0-101.797 82.52-184.32 184.32-184.32zM512.008 275.024c-53.323 0-96.549 43.227-96.549 96.549 0 53.325 43.224 96.55 96.549 96.55s96.55-43.226 96.55-96.55c0-53.322-43.226-96.549-96.55-96.549z',
			'M512.008 0c282.765 0.003 511.989 229.242 511.992 512.008-0.002 123.112-43.466 236.066-115.869 324.379-0.344 0.432-0.685 0.866-1.046 1.286-93.906 113.792-236.018 186.325-395.077 186.326-159.125-0.002-301.288-72.592-395.196-186.464-0.116-0.136-0.229-0.274-0.343-0.411-72.765-88.421-116.468-201.667-116.469-325.117 0.003-282.766 229.242-512.006 512.008-512.008zM512.008 719.73c-120.752 0.002-203.738 31.144-255.669 60.824-18.901 10.802-33.853 21.498-45.104 30.6 76.835 77.246 183.213 125.074 300.773 125.075 117.555-0.002 223.925-47.832 300.757-125.075-11.25-9.101-26.178-19.803-45.069-30.6-51.933-29.682-134.93-60.822-255.688-60.824zM512.008 87.772c-234.291 0.002-424.233 189.945-424.236 424.236 0.001 85.155 25.123 164.437 68.315 230.882 14.638-11.837 33.437-25.245 56.691-38.538 64.606-36.923 162.536-72.394 299.23-72.394 136.699 0 234.626 35.47 299.23 72.394 23.251 13.29 42.035 26.702 56.675 38.538 43.192-66.445 68.314-145.725 68.315-230.882-0.005-234.291-189.931-424.233-424.221-424.236z',
		],
		tags: ['user circle'],
	},
	attrs: [{}, {}],
	properties: {
		code: 59752,
		id: 9,
		name: 'user-circle-o-2',
		order: 3425,
		prevSize: 20,
	},
	setIdx: 0,
	setId: 2,
	iconIdx: 4,
};

// Create IconBuilder from cond-ui-kit data
// Note: NavigationIcon component will conditionally use old navigation icons when needed
const AccountIconBuilder: IconBuilder = createIconBuilderFromCondUiKit(
	userCircleO2IconData as any,
	'#89c32e', // Default green color for new navigation
);

export default AccountIconBuilder;

